import { forwardRef } from 'react';

import type { TextFieldModel } from '../../../types';
import Box from '../../Button/Box';
import Icon from '../../Icon';
import BaseStyleTextField from '../BaseStyleTextField';

import s from './CodeTextField.module.scss';

export interface CodeTextFieldProps extends TextFieldModel {
  timer: string;
  onClick: () => void;
  buttonLabel: string;
}

const CodeTextField = forwardRef<HTMLInputElement, CodeTextFieldProps>(({ timer, buttonLabel, onClick, success, ...props }, ref) => {
  return (
    <BaseStyleTextField {...props} ref={ref}>
      {success ? (
        <Icon className={s.icon} type="check-mark" size={24} color="green.600" />
      ) : (
        <>
          <span className={s.timer}>{timer}</span>
          <Box state="primary" size="small" onClick={onClick}>
            {buttonLabel}
          </Box>
        </>
      )}
    </BaseStyleTextField>
  );
});

export default CodeTextField;
